export default function ({ $gtm }) {
  $gtm.init('GTM-5C2QT8H')
}
